import React, { useMemo, useState } from 'react'
import { Alert, Button, Empty, Input, Skeleton, Tag, Tooltip, Tree } from 'antd'
import { indexNavigation, searchNavigation } from './navigation'
import HelpHint from './HelpHint'

// 2026-10-20 coder(lq): 树节点数量是接口关系数（含子菜单），不是去重接口数或用户权限数量。
export default function MenuNavigation({ root, selectedKey, loading, error, onRetry, onSelect }) {
    const [search, setSearch] = useState('')
    const [expanded, setExpanded] = useState(null)
    const tree = useMemo(() => searchNavigation(root, search), [root, search])
    const navigation = useMemo(() => indexNavigation(root), [root])
    const defaults = root ? [root.key, ...(root.children || []).map(node => node.key)] : []
    const searchExpanded = tree.length ? Array.from(indexNavigation(tree[0]).nodes.keys()) : []
    return <aside className="menu-api-navigation" aria-label="系统与菜单导航">
        <div className="menu-api-navigation-heading"><strong>系统与菜单
            <HelpHint label="系统与菜单数量说明">数量为接口关系数，包含子菜单；零关系菜单也会展示。</HelpHint>
        </strong><Button size="small" onClick={onRetry} loading={loading}>刷新树</Button></div>
        <Input allowClear aria-label="搜索系统或菜单" placeholder="搜索系统、菜单名称或 ID" value={search} onChange={event => setSearch(event.target.value)} />
        {loading ? <Skeleton active paragraph={{ rows: 6 }} /> : error ? <Alert type="error" showIcon message={error}
            action={<Button size="small" onClick={onRetry}>重试</Button>} /> : tree.length ?
            <div className="menu-api-tree-scroll"><Tree aria-label="系统菜单树" blockNode showLine treeData={tree}
                expandedKeys={search.trim() ? searchExpanded : (expanded || defaults)} onExpand={keys => setExpanded(keys)}
                selectedKeys={[selectedKey]} onSelect={keys => {
                    if (!keys.length) return
                    // 2026-10-20 coder(lq): 清空搜索后仍展开选中菜单的父链，避免定位结果重新藏回目录。
                    setExpanded(previous => Array.from(new Set([...(previous || defaults), ...(navigation.ancestors.get(keys[0]) || [])])))
                    onSelect(keys[0])
                }}
                titleRender={node => <span className="menu-api-tree-title">
                    <Tooltip title={[node.title, node.menu && `${node.menu.authority} / ${node.menu.service_id} / #${node.menu.resource_id}`].filter(Boolean).join(' · ')}>
                        <span className="menu-api-tree-label">{node.title}{node.kind === 'CONTEXT' && <small>（目录）</small>}</span>
                    </Tooltip>
                    <Tag title="含子菜单的接口关系数">{node.relationCount}</Tag>
                    {node.canAdd && node.relationCount === 0 && <small className="menu-api-tree-unconfigured">未配置</small>}
                </span>} /></div> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="没有匹配的系统或菜单" />}
        {root && root.hierarchyWarnings > 0 && <Alert type="warning" message="存在父级缺失或循环菜单，已按可读取目录展示，请核对原菜单层级。" />}
    </aside>
}
